"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const E = require("fp-ts/lib/Either");
const _1 = require(".");
const pipeable_1 = require("fp-ts/lib/pipeable");
exports.nonNullable = (path) => (x) => pipeable_1.pipe(x, E.fromNullable([new _1.ValidationError(path, 'value must be non nullable', new NotNilInfo())]));
class NotNilInfo {
    constructor() {
        this.type = 'notNil';
    }
}
